















































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { BlockLabel } from "@/models/BlockLabel";
import { Expandable, TextField } from "@/components";

export default defineComponent({
  name: "EnsureNetPrice",
  components: {
    Expandable,
    TextField,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      netPrice: 1000,
      percentToContingent: 34,
      description: "",
      displayName: BlockLabel.EnsureNetPrice,
    };
  },
  mounted() {
    if (this.data) {
      this.netPrice = this.data.netPrice;
      this.percentToContingent = this.data.percentToContingent;
      this.description = this.data.description;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        netPrice: this.netPrice,
        percentToContingent: this.percentToContingent,
        description: this.description,
      });
    },
    getEnsureNetPriceText(): string {
      return `Medlemmer av denne organisasjonen får en total netto på ${
        this.netPrice
      } ved at ${NumberFormatter.atMostTwoDecimalPlaces(
        this.percentToContingent
      )} % av differansen tilegges kontingenten og ${NumberFormatter.atMostTwoDecimalPlaces(
        100 - this.percentToContingent
      )} % serviceavgiften.`;
    },
    asCurrency(number: number) {
      return `kr ${NumberFormatter.withThousandsSeparator(number, " ")}`;
    },
    getCalculationTypeLabel(): string {
      return this.calculationType == 0 ? "kontingent" : "serviceavgift";
    },
  },
});
